<script>
   import Layout from '../../layouts/main'
   import PageHeader from '@/components/page-header'
   import appConfig from "@/app.config";
    
   export default {
      page: {
         title: "Consultation Details",
         meta: [
            {
               name: "description",
               content: appConfig.description,
            },
         ],
      },
      components: { Layout, PageHeader },
      data() {
         return {
            title: "Consultation Details",
            items: [
               {
                  text: "Consultations",
                  href: "/consultations",
               },                
               
               {
                  text: "Details",
                  active: true,
               },                     
            ],

            consultation: {},
            doctor: {},
            patient: {},
            payment: {},
            questions:[],
         };
      },
      mounted() {
    
      },

      created() {
         this.fetchConsultation();
      },

      methods: {

         getToken() {
            if (localStorage.getItem('medicino_admin')) {
               var medicino_admin =  JSON.parse(localStorage.getItem('medicino_admin'));
               if(medicino_admin.token) {
                  this.token = medicino_admin.token;
               } else {
                  this.$swal("", "Failed to fetch token, please login again", "error");
                  this.$router.push({ name: "login" });
               }
               
            } else {
               this.$swal("", "Session expired, please login again", "error");
               this.$router.push({ name: "login" });
            }
         }, 

         fetchConsultation() {
            let url = "api/admin/consultation_details_new?booking_id=" + this.$route.params.id;         
            this.getToken();
            this.loading = true;
            this.$axios
            .get(url, { headers: { Authorization: "Bearer " + this.token } })
            .then((res) => {
               var responseData = res.data.data;
               console.log(responseData);
               this.consultation = responseData.consultation_details;  
               if(!this.consultation) {
                  this.$swal("", "Not Found", "error");
                  this.$router.push({ name: "consultations" });
               }
               this.doctor = responseData.doctor_other_datails;
               this.patient = responseData.patient_other_details;
               this.payment = responseData.payment_details;             
               this.questions = responseData.questions;             
            })
            .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        if(typeof error.response.data.message === 'object') {
                           console.log(error.response.status);
                        } else {
                           this.$swal("", error.response.data.message, "error");
                        }                        
                        
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
            })
            .finally(() => (this.loading = false));
         },
      }
   }
</script>
    
<template>
   <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
         <div class="col-12">
            <div class="card">
               <div class="card-body">
                  <!-- <h4 class="card-title"></h4>
                  <p class="card-title-desc"></p> -->

                  <!----- top button area starts---->
                  <div class="row mb-3">
                     <div class="col-12">

                        <a href="#" @click.prevent="$router.go(-1)" class="btn btn-primary float-end"><i class='bx bx-chevrons-left'></i> Back</a>
                       
                     </div>
                  </div>
                  <!----- top button area ends---->                  

                  <!---- listing table starts -------->
                  <div class="row">
                     <div class=" col-md-6 col-lg-6">
                        <b-card header-class="bg-transparent border-light" class="border border-light">
                           
                           <div class="table-responsive">
                              <table class="table mb-0">
                                 
                                 <tbody>                                    
                                    
                                    <tr>
                                       <th>Patient Name</th>
                                       <th>:</th>
                                       <td><span v-if="consultation.member_id">{{patient.member_name}}</span><span v-else>{{consultation.patient_name}}</span></td>
                                    </tr>              
                                    
                                    <tr>
                                       <th>Token No</th>
                                       <th>:</th>
                                       <td>{{consultation.token}}</td>
                                    </tr>

                                    <tr>
                                       <th>Doctor Name</th>
                                       <th>:</th>
                                       <td><span v-if="consultation.prefix == 1">Dr. </span><span v-else-if="consultation.prefix == 2">Mr. </span><span v-else-if="consultation.prefix == 3">Ms. </span> {{consultation.doctor_name}}</td>
                                    </tr>

                                    <tr>
                                       <th>Consultation Type</th>
                                       <th>:</th>
                                       <td>
                                          <span v-if="consultation.consultation_type==1">Video</span>
                                          <span v-if="consultation.consultation_type==2">Home</span>
                                          <span v-if="consultation.consultation_type==3">Clinic</span>
                                       </td>
                                    </tr>
                                    <tr span v-if="consultation.consultation_type==3">
                                       <th>Clinic</th>
                                       <th>:</th>
                                       <td>
                                          {{consultation.clinic_name}}
                                       </td>
                                    </tr>

                                    <tr>
                                       <th>Booking Date</th>
                                       <th>:</th>
                                       <td>{{consultation.booking_date | formatDate}}</td>
                                    </tr>                                    

                                    <tr>
                                       <th>Booking Slot</th>
                                       <th>:</th>
                                       <td>{{consultation.consultation_start | formatTime}} - {{consultation.consultation_end | formatTime}}</td>
                                    </tr>

                                    <tr>
                                       <th>Created by</th>
                                       <th>:</th>
                                       <td>
                                          <span v-if="consultation.added_by==1">Patient</span>
                                          <span v-if="consultation.added_by==2">Admin</span>
                                          <span v-if="consultation.added_by==3">Clinic</span>
                                          <!-- <span v-if="consultation.added_by==4">Clinic</span><br> -->
                                       </td>
                                    </tr>

                                    <tr>
                                       <th>Created on</th>
                                       <th>:</th>
                                       <td>{{consultation.converted_created_at}}</td>
                                    </tr>

                                    <tr>
                                       <th>Status</th>
                                       <th>:</th>
                                       <td>
                                          <span v-if="consultation.status==1">Pending</span>
                                          <span v-if="consultation.status==2">Completed</span>
                                          <span v-if="consultation.status==3"><span v-if="consultation.cancelled_status==3 && consultation.cancelled_reason==1" >Rescheduled</span><span v-else>Cancelled</span></span>
                                          <span v-if="consultation.status==4">Not shown</span>
                                       </td>
                                    </tr>

                                    <tr  v-if="consultation.status==3">
                                       <th>Cancelled Reason</th>
                                       <th>:</th>
                                       <td>
                                          <span v-if="consultation.cancelled_reason_text">{{consultation.cancelled_reason_text}}</span>
                                          <span v-else-if="consultation.cancelled_reason==1">Doctor's Leave</span>
                                       </td>
                                    </tr>
                                    <tr  v-if="consultation.status==3 && consultation.cancelled_status ==2">
                                       <th>Cancelled by</th>
                                       <th>:</th>
                                       <td>
                                          <span v-if="consultation.cancel_by == 1">Admin</span>
                                          <span v-if="consultation.cancel_by == 3">Patient</span>
                                          <span v-if="consultation.cancel_by == 4">Clinic</span>
                                       </td>
                                    </tr>

                                    <tr  v-if="consultation.status==3 && consultation.cancelled_status ==2">
                                       <th>Cancelled at</th>
                                       <th>:</th>
                                       <td>
                                          {{consultation.cancelled_at | formatDateTime}}
                                       </td>
                                    </tr>
                                    <tr  v-if="consultation.status==3 && consultation.cancelled_status ==2">
                                       <th>Refund</th>
                                       <th>:</th>
                                       <td>
                                          <span v-if="consultation.refund_status == 2">Completed <span v-if="consultation.refund_type == 1">(Fully)</span><span v-else-if="consultation.refund_type == 2"> (Partially)</span><span v-else-if="consultation.refund_type == 3"> (No Refund)</span></span>
                                          <span v-else>Pending</span>

                                       </td>
                                    </tr>

                                 </tbody>
                              </table>
                           </div>
                        </b-card>
                        <b-card header-class="bg-transparent border-light" class="border border-light" v-if="questions.length && consultation.added_by==1">
                           <h4 class="font-size-18 bg-light  border border-top-0 border-start-0 border-end-0 p-3 mb-3">Symptoms Questions & Answers</h4>
                           <div class="table-responsive">
                              <table class="table mb-0">
                                 
                                 <tbody>                                   
                                    <tr v-for="(question) in questions" :key="question.id">
                                       <td>
                                          <div style="display: flex; justify-content: space-between; align-items: center;">
                                             <h5>{{question.i}}. {{question.question}}</h5>
                                             <table class="table mb-0" v-if="Boolean(question.subquestions.length)">
                                                <tbody>                                   
                                                   <tr v-for="(sub) in question.subquestions" :key="sub.id"> 
                                                      <td>
                                                         <div style="display: flex; justify-content: space-between; align-items: center;">
                                                            <h6>
                                                               <li>{{ sub.sub_question }}</li>
                                                            </h6>
                                                            <div class="text-danger">
                                                               <p v-if="sub.value" disabled> Yes </p>
                                                               <p v-else disabled> No </p>
                                                            </div>
                                                         </div>
                                                      </td>
                                                   </tr>
                                                   
                                                </tbody>
                                             </table>
                                             <tbody v-else>
                                                <tr>
                                                   <div class="text-danger" style="margin-right: 12px;">
                                                      <p v-if="question.value" disabled> Yes </p>
                                                      <p v-else disabled> No </p>
                                                   </div>
                                                </tr>
                                             </tbody>
                                          </div>
                                       </td>
                                    </tr>  
                                    <tr v-if="consultation.symptom_note">
                                       <td>
                                          <h5>Notes</h5>
                                          <p>{{consultation.symptom_note}}</p>
                                       </td>
                                    </tr>  
                                 </tbody>
                              </table>
                           </div>
                        </b-card>
                        <b-card header-class="bg-transparent border-light" class="border border-light">
                           <h4 class="font-size-18 bg-light  border border-top-0 border-start-0 border-end-0 p-3 mb-3">Payment Details</h4>
                           <div class="table-responsive">
                              <table class="table mb-0">
                                 <tbody v-if="payment">
                                    <tr>
                                       <th>Payment Type</th>
                                       <th>:</th>
                                       <td>{{payment.payment_type}}</td>
                                    </tr>

                                    <tr>
                                       <th>Payment ID</th>
                                       <th>:</th>
                                       <td>{{payment.payment_id}}</td>
                                    </tr>

                                    <!-- <tr>
                                       <th>Amount</th>
                                       <th>:</th>
                                       <td>Rs. {{payment.total_amount}}</td>
                                    </tr> -->
                                    <tr>
                                       <th>Consultation Fee</th>
                                       <th>:</th>
                                       <td><span v-if="payment.consultation_fee">Rs. {{payment.consultation_fee}}</span></td>
                                    </tr>

                                    <tr v-if="payment.consultation_type == 1">
                                       <th>Platform Fee</th>
                                       <th>:</th>
                                       <td><span v-if="payment.commision">Rs. {{payment.commision}}</span></td>
                                    </tr>

                                    <tr v-if="payment.consultation_type != 1">
                                       <th>Convenience Fee</th>
                                       <th>:</th>
                                       <td><span v-if="payment.convenience_fee">Rs. {{payment.convenience_fee}}</span></td>
                                    </tr>


                                    <tr v-if="payment.discount">
                                       <th>Discount</th>
                                       <th>:</th>
                                       <td>Rs. {{payment.discount}}
                                          <span v-if="payment.discount">{{payment.coupon_code}}</span>
                                       </td>
                                    </tr>

                                    <tr>
                                       <th>Payment On</th>
                                       <th>:</th>
                                       <td><span v-if="payment.updated_at">{{payment.converted_updated_at}}</span></td>
                                    </tr>

                                    <tr>
                                       <th>Total</th>
                                       <th>:</th>
                                       <td>Rs. {{(payment.total_amount - payment.discount).toFixed(2)}}</td>
                                    </tr>
                                 </tbody>
                                 <tbody v-else>
                                    <tr>No Payment Details</tr>
                                 </tbody>
                              </table>
                           </div>
                        </b-card>
                     </div>
                     <div class=" col-md-6 col-lg-6">
                        <b-card header-class="bg-transparent border-light" class="border border-light">
                           <h4 class="font-size-18 bg-light  border border-top-0 border-start-0 border-end-0 p-3 mb-3">User Details</h4>
                           <div class="table-responsive">
                              <table class="table mb-0">
                                 <tbody>

                                    <tr>
                                       <th>User ID</th>
                                       <th>:</th>
                                       <td>{{patient.patient_id}}</td>
                                    </tr>
                                    <tr>
                                       <th>Name</th>
                                       <th>:</th>
                                       <td>{{patient.name}}</td>
                                    </tr>

                                    <tr>
                                       <th>Mobile</th>
                                       <th>:</th>
                                       <td>+91 {{patient.mobile}}</td>
                                    </tr>
                                    
                                    <tr>
                                       <th>Email</th>
                                       <th>:</th>
                                       <td>{{patient.email}}</td>
                                    </tr>

                                    <tr>
                                       <th>Gender</th>
                                       <th>:</th>
                                       <td>
                                          <span v-if="patient.gender==1">Male</span>
                                          <span v-if="patient.gender==2">Female</span>
                                          <span v-if="patient.gender==3">Others</span>
                                       </td>
                                    </tr>                                

                                    <tr>
                                       <th>D.O.B</th>
                                       <th>:</th>
                                       <td>{{patient.dob | formatDate}}</td>
                                    </tr>

                                    <tr>
                                       <th>Address</th>
                                       <th>:</th>
                                       <td>{{patient.address}}</td>
                                    </tr> 

                                    <tr>
                                       <th>Pincode</th>
                                       <th>:</th>
                                       <td>{{patient.pincode}}</td>
                                    </tr>                                          
                                    
                                 </tbody>
                              </table>
                           </div>
                        </b-card>
                        <b-card header-class="bg-transparent border-light" class="border border-light" v-if="patient.member_id">
                           <h4 class="font-size-16 bg-light  border border-top-0 border-start-0 border-end-0 py-2 px-3 mb-3">Member Details</h4>
                           <div class="table-responsive">
                              <table class="table mb-0">
                                 <tbody>

                                    <tr>
                                       <th>Member ID</th>
                                       <th>:</th>
                                       <td>{{patient.member_id}}</td>
                                    </tr>
                                    
                                    <tr>
                                       <th>Name</th>
                                       <th>:</th>
                                       <td>{{patient.member_name}}</td>
                                    </tr>

                                    <tr>
                                       <th>Gender</th>
                                       <th>:</th>
                                       <td>
                                          <!-- {{patient.member_gender}} -->
                                          <span v-if="patient.member_gender==1">Male</span>
                                          <span v-if="patient.member_gender==2">Female</span>
                                          <span v-if="patient.member_gender==3">Others</span>
                                       </td>
                                    </tr>                                

                                    <tr>
                                       <th>D.O.B</th>
                                       <th>:</th>
                                       <td>{{patient.member_dob}}</td>
                                    </tr>

                                                                        
                                 </tbody>
                              </table>
                           </div>
                        </b-card>

                        <b-card header-class="bg-transparent border-light" class="border border-light">
                           <h4 class="font-size-18 bg-light border border-top-0 border-start-0 border-end-0 p-3 mb-3">Doctor Details</h4>
                           <div class="table-responsive">
                              <table class="table mb-0">
                                 <tbody>
                                    <tr>
                                       <th>Doctor ID</th>
                                       <th>:</th>
                                       <td> <span v-if="doctor.code">{{doctor.code}}</span></td>
                                    </tr>
                                    <tr>
                                       <th>Mobile</th>
                                       <th>:</th>
                                       <td>+91 {{doctor.mobile}}</td>
                                    </tr>

                                    <tr>
                                       <th>Email</th>
                                       <th>:</th>
                                       <td>{{doctor.email}}</td>
                                    </tr>

                                    <tr>
                                       <th>Gender</th>
                                       <th>:</th>
                                       <td>
                                          <span v-if="doctor.gender==1">Male</span>
                                          <span v-if="doctor.gender==2">Female</span>
                                          <span v-if="doctor.gender==3">Others</span>
                                       </td>
                                    </tr>                     
                            
                                    <tr>
                                       <th>Address</th>
                                       <th>:</th>
                                       <td>{{doctor.address}}</td>
                                    </tr>

                                    <tr>
                                       <th>Specializations</th>
                                       <th>:</th>
                                       <td>
                                          <span v-for="(specialization) in doctor.specializations" :key="specialization.id">{{specialization.specialization}}<br></span>
                                       </td>
                                    </tr>

                                    <tr>
                                       <th>Languages</th>
                                       <th>:</th>
                                       <td>
                                          <span v-for="(language) in doctor.languages" :key="language.id">{{language.language}}<br></span>
                                       </td>
                                    </tr>

                                 </tbody>
                              </table>
                           </div>
                        </b-card>
                     </div>
                  </div>
                  <!---- listing table ends -------->

               </div>
            </div>
         </div>
      </div>
   </Layout>
</template>
